import { Case } from '../match';
import { Action, NavAction } from '../actions';
import { DataLoader } from './data-loader';
import { InputField } from './input-field';
import { NonExistantRouteError } from '../errors';

export type PropsMap = {
  [key: string]: any;
};

export type FlowNode = {
  route: string;
  screen: any;
  preLoad?: Case<Action>[];
  startsPersistingSensitive?: boolean;
  startsPersistingFunding?: boolean;
  load?: DataLoader;
  postLoad?: {
    default?: NavAction;
    cases?: Case<NavAction>[];
  };
  form?: InputField[];
  preCommit?: Case<Action>[];
  commit?: DataLoader;
  next: {
    default: NavAction;
    cases?: Case<NavAction>[];
  };
  flowProps?: PropsMap;
  back?: {
    default: NavAction;
    cases?: Case<NavAction>[];
  };
};

export interface FlowLike {
  nodes: FlowNode[];
  namespace: string;
  flowProps?: PropsMap;
  start: string;
  pageDecorators?: any;
  onLoad?: DataLoader | DataLoader[];
  onApplicationLoad?: Function;
  onCommit?: DataLoader | DataLoader[];
}

type Pair = [string, FlowNode];

export class Flow implements FlowLike {
  private routeMap: Map<string, FlowNode>;

  nodes: FlowNode[];

  namespace: string;

  start: string;

  flowProps?: PropsMap;

  pageDecorators?: any;

  onLoad?: DataLoader | DataLoader[];

  onCommit?: DataLoader | DataLoader[];

  onApplicationLoad?: Function;

  constructor({
    nodes,
    namespace,
    start,
    flowProps,
    pageDecorators,
    onLoad,
    onCommit,
    onApplicationLoad
  }: FlowLike) {
    this.nodes = nodes;
    this.namespace = namespace;
    this.start = start;
    this.flowProps = flowProps;
    this.pageDecorators = pageDecorators;
    this.onLoad = onLoad;
    this.onCommit = onCommit;
    this.onApplicationLoad = onApplicationLoad;

    const pairs: Array<Pair> = this.nodes.reduce(
      (m, node) => [...m, [node.route, node]],
      []
    );
    this.routeMap = new Map(pairs);
  }

  getStartNode(): FlowNode {
    const startNode = this.routeMap.get(this.start);
    if (!startNode) throw new NonExistantRouteError('Start route not found');
    return startNode;
  }
}
